import { useSelector } from 'react-redux';

const useGetUserRole = () => {
  const role = useSelector((state) => state.auth.userDetails.role);

  return role;
};

export default useGetUserRole;
